import { Directive, HostListener, input } from '@angular/core';

/** Decimal pattern for paste validation — digits only, no sign or separators. */
const NUMBERS_ONLY_PATTERN = /^\d+$/;

/**
 * Restricts input to digits only (keypress + paste).
 * Pass `false` to disable without removing the attribute.
 */
@Directive({
    selector: '[ancNumbersOnly]',
    standalone: true
})
export class AncNumbersOnlyDirective {
    /** When false, the directive is inert. */
    ancNumbersOnly = input(true);

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent): void {
        if (!this.ancNumbersOnly()) {
            return;
        }

        const char = event.key;

        if (event.ctrlKey || event.metaKey || char.length !== 1) {
            return;
        }

        if (!/^\d$/.test(char)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        if (!this.ancNumbersOnly()) {
            return;
        }

        const pastedInput = event.clipboardData?.getData('text') ?? '';

        if (!NUMBERS_ONLY_PATTERN.test(pastedInput)) {
            event.preventDefault();
        }
    }
}
